import React from 'react'
import { hasCurrentReservation, getNextCheckInReservation, formatCheckInDate } from '../../utils/work-order-occupancy'
import { WorkOrderBadge } from '../job-indicators'

/**
 * Renders the current occupancy state on work order cards once reservation data has loaded.
 * Place this in the header badges row alongside Urgent, Streamline, and Status badges.
 */
export const OccupancyBadge = ({ propertyId, reservationsByProperty }) => {
  if (!reservationsByProperty || !propertyId || !reservationsByProperty[propertyId]) return null

  const isOccupied = hasCurrentReservation(propertyId, reservationsByProperty)

  if (isOccupied) {
    return (
      <WorkOrderBadge className="bg-green-100 text-green-800">
        <svg className="h-3 w-3 sm:h-4 sm:w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        Occupied
      </WorkOrderBadge>
    )
  }

  return (
    <WorkOrderBadge className="bg-amber-100 text-amber-800">
      Unoccupied
    </WorkOrderBadge>
  )
}

export const UnoccupiedBadge = OccupancyBadge

/**
 * Renders a "Next check-in: Date" row below the description for unoccupied properties.
 */
export const NextCheckInRow = ({ propertyId, reservationsByProperty }) => {
  if (!reservationsByProperty || hasCurrentReservation(propertyId, reservationsByProperty)) return null

  const next = getNextCheckInReservation(propertyId, reservationsByProperty)
  if (!next) return null

  return (
    <div className="flex items-center py-1 px-2 bg-amber-50 rounded text-xs text-amber-800 w-fit">
      <svg className="h-3 w-3 mr-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <span>Next check-in: {formatCheckInDate(next.check_in)}</span>
    </div>
  )
}

export default { OccupancyBadge, UnoccupiedBadge, NextCheckInRow }
